import { resetUserState } from "store/global/GlobalStore";
import { useAccount, useDisconnect } from "wagmi";

export const useDisconnectInternal = () => {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  return () => {
    if (disconnect) {
      disconnect();
      resetUserState();
    } else {
      if (address == null) {
        console.error("Cannot use `disconnect` here. User has not connected wallet.");
      } else {
        console.error("Wagmi error: `disconnect` cannot be found");
      }
    }
  };
};
